import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { RfqPurchaseOrdersPage } from '@/areas/purchase-orders/PurchaseOrders/RfqPurchaseOrdersPage/RfqPurchaseOrdersPage';
import { canViewPurchaseOrders } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders',
)({
    staticData: { access: { permissions: canViewPurchaseOrders }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <RfqPurchaseOrdersPage rfqId={pathParams.projectId} sourcingScenarioId={pathParams.sourcingScenarioId} />;
}
